import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth";
import { App } from "./App";
import "./styles.css";
import { ThemeProvider } from "./theme";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });
createRoot(document.getElementById("root")!).render(<StrictMode><ThemeProvider><QueryClientProvider client={queryClient}><AuthProvider><App /></AuthProvider></QueryClientProvider></ThemeProvider></StrictMode>);
